export default __webpack_public_path__ + "static/media/PowellCatLocation-15.16ec3ce4.jpg";